import React from 'react';
import { Tooltip } from 'react-tooltip';
import useVariables from 'src/hooks/useVariables';
import { Variable } from 'src/api/types';
import { useTheme } from 'styled-components';
import { parseToJsx } from './util';
import * as S from './FormulaPreview.styles';

interface FormulaPreviewProps {
  value?: string | number | null;
  /** Optional pre-loaded variables (avoids a second fetch); falls back to useVariables. */
  variables?: Variable[];
  /** Reveal each variable's resolved value on hover (like the edit-form chips). */
  showValueOnHover?: boolean;
  /** When set, each resolved variable pill becomes clickable and reports its id. */
  onVariableClick?: (variableId: number) => void;
}

const FormulaPreview: React.FC<FormulaPreviewProps> = ({
  value,
  variables: variablesProp,
  showValueOnHover,
  onVariableClick,
}) => {
  const { variables: hookVariables } = useVariables({});
  const colors = useTheme().colors;
  // One tooltip per FormulaPreview instance, shared by all its chips (rendered
  // outside the flex row so it never affects layout).
  const tooltipId = React.useId();
  const variables = variablesProp ?? hookVariables ?? [];

  if (value == null || value === '') return null;

  return (
    <>
      {showValueOnHover && (
        <Tooltip id={tooltipId} style={{ backgroundColor: colors.prussianBlue, zIndex: 10, color: colors.white }} opacity={1} />
      )}
      <S.Div>{parseToJsx(value, variables, { showValueOnHover, tooltipId, onVariableClick })}</S.Div>
    </>
  );
};

export default FormulaPreview;
